import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PhonesDto } from '@app/data/dtos/ptrab/shared/phones.dto';
import { TwoFactorDto, TwoFactorUserStatusDto } from '@app/data/dtos/ptrab/two-factor/two-factor.dto';
import { ValidateCodeDto } from '@app/data/dtos/ptrab/two-factor/validate-code.dto';
import { mapPhones, mapTwoFactor, mapvalidateCode } from '@app/data/mappers/ptrab/two-factor/two-factor.mappers';
import { TwoFactorOperationCode } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { Phones } from '@app/entities/models/ptrab/shared/phone.model';
import { TwoFactor } from '@app/entities/models/ptrab/two-factor/two-factor.model';
import { ENV } from '@environments/environment';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class TwoFactorRepositoryImpl extends MRepository {
  constructor() {
    super(`${ENV.API_URL_USERS}`);
  }

  getPhoneList(): Observable<Phones> {
    return this.get<PhonesDto>(`/user/v2/phones`).pipe(map(mapPhones));
  }

  sendValidationCodeToPhone(operation: TwoFactorOperationCode, phone: string): Observable<TwoFactor> {
    const request = {
      body: { operation, phone }
    };
    return this.post<TwoFactorDto>('/2fa', request).pipe(map(mapTwoFactor));
  }

  validateCode(operation: TwoFactorOperationCode, code: string, phone?: string): Observable<string> {
    const request = {
      body: { operation, code, phone }
    };
    return this.post<ValidateCodeDto>('/2fa/validate', request).pipe(map(mapvalidateCode));
  }

  getUserStatus() {
    return this.get<TwoFactorUserStatusDto>('/2fa/status');
  }
}
